/**
 * Language names for the switcher. The API sends locales only (C-03): the client names them with
 * `Intl.DisplayNames`, falling back to the code when the browser can't.
 */

const subtag = (locale: string): string => locale.split(/[-_]/)[0];

const display = (locale: string, inLocale: string): string | null => {
  try {
    if (typeof Intl.DisplayNames !== 'function') return null;
    const name = new Intl.DisplayNames([inLocale], { type: 'language' }).of(
      subtag(locale)
    );
    return name && name !== subtag(locale) ? name : null;
  } catch {
    return null; // not a well-formed language code
  }
};

/** English name of the locale's language ("Greek"), else the locale code. */
export const languageName = (locale: string): string =>
  display(locale, 'en') ?? locale;

/** The language's name in itself ("Ελληνικά"), else the locale code. */
export const nativeLanguageName = (locale: string): string =>
  display(locale, subtag(locale)) ?? locale;

/** Short mark for the button and rows: the language subtag in capitals ("EL"). */
export const languageBadge = (locale: string): string =>
  subtag(locale).toUpperCase();
